export interface MailDTO {
    id: number;
    recipients: string;
    subject: string;
    stringBody: string;
    status: string;
}

export interface MailWriteDTO {
    recipients: string;
    subject: string;
    stringBody: string;
    status: string;
}

export function createMail( recipients: string, subject: string, stringBody: string, status: string) {
    return { recipients: recipients, subject: subject, stringBody: stringBody, status: status};
}